<template>
    <header class="story__head">
        <h1 class="title title--dash">
            <span 
                data-v-line 
                v-html="formatLine(line, i)"
                v-for="(line, i) in getLines(title)" 
                :key="`head-${i}`" 
            />
        </h1>
        <template v-if="subtitle">
            <h2 
                class="subtitle--header text--upper" 
                :class="{
                    'fn': i < 1 
                }"
                v-html="formatLine(line, i)"
                v-for="(line, i) in getLines(subtitle)" 
                :key="`sub-${i}`" 
            />
        </template>
    </header>
</template>

<script>
export default {
    props: {
        title: [Array, String],
        subtitle: [Array, String],
    },
    methods: {
        getLines( text ) {
            return Array.isArray(text) ? text : [text]
        },
        formatLine( text, i ) {
            if ( !i ) {
                return `${text}&nbsp;`
            }
            return text
        },
    },
}
</script>